export const asidePartnerPermision = 'partners'
export const asideProjectsPermision = 'project'
export const informersGroupPermision = 'organizationdetails,acc,permission,user,donor,organizationtypes,servicetypes,statuses,sphere,positionandservice,bank,currency,unit,languages,tax,expancecategory,location,filetag'


export const informersDescription = `Արտարծույքները կարող եք ավելացնել ներքոհիշհալ դաշտում նշելով ցանկացած արտարժուք, որից հետո անհրաժեշտ է սեղմել "Ավելացնել" կոճակը: Իսկ եթե արտարժուքն ավելացնելուց տեղի է ունեցել վրիպում ապա ավելացված արտաժույքների դաշտում սեղմեք փոփոխել կոճակը և կատարեք փոփխությունները: Ցանկանում եք հեռացնել ոչ պիտանի արտարժուքը ապա սեղմեք ռեռացնել կոճակը`

